module.exports = __webpack_public_path__ + "static/uebersicht-fdcb76f8bb6bd33a4a9a0405cf4e9d7c.jpg";